// extracted by mini-css-extract-plugin
export default {"payLink":"unpaid-order-alert_payLink__4ZcPE"};